import { LegacyCard, DropZone, Layout, Page, LegacyStack, Text, Thumbnail } from '@shopify/polaris';
import { useContext, useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { HorizontalDotsMinor } from '@shopify/polaris-icons';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { postTransfersFileEPH } from '../../../services/transfersService';

const UploadTransfersFileEPH = () => {
  return (
    <Page title="Crear transferencias con fichero EPH" divider>
      <FileInputState />
    </Page>
  );
};

export default UploadTransfersFileEPH;

const FileInputState = ({ onFileCharged }) => {
  const [files, setFiles] = useState([]);
  const [, dispatchToast] = useContext(ToastContext);

  const handleDropZoneDrop = (_dropFiles, acceptedFiles, _rejectedFiles) => handleFileUpload([...acceptedFiles]);

  const validImageTypes = ['text/plain'];

  const fileUpload = !files.length && <DropZone.FileUpload />;
  const uploadedFiles = files.length > 0 && (
    <LegacyStack vertical>
      {files.map((file, index) => (
        <LegacyStack alignment="center" key={index}>
          <Thumbnail
            size="small"
            alt={file.name}
            source={validImageTypes.includes(file.type) ? window.URL.createObjectURL(file) : HorizontalDotsMinor}
          />
          <div style={{ padding: 10 }}>
            {file.name}{' '}
            <Text variant="headingSm" as="h6">
              {file.size} bytes
            </Text>
          </div>
        </LegacyStack>
      ))}
    </LegacyStack>
  );

  const handleFileUpload = (acceptedFiles) => {
    setFiles(acceptedFiles);
    for (let i = 0; i < acceptedFiles.length; i++) {
      const f = acceptedFiles[i];
      const form = new FormData();
      form.append('file', f, f.name);

      postTransfersFileEPH(form)
        .then((r) => {
          dispatchToast({ type: SET_OK, payload: r.data });
          //   onFileCharged(r.data.inventories);
        })
        .catch((e) => {
          dispatchToast({ type: SET_ERROR, payload: e.response.data });
        })
        .finally(() => {
          setFiles(files.filter((file) => file.name !== f.name));
        });
    }
    // eslint-disable-next-line
  };

  return (
    <Layout>
      <Layout.Section secondary>
        <Text variant="bodyMd" as="p" color="subdued">
          Añada un fichero de transferencias del EDIWIN tienda en formato CSV.
        </Text>
        <br />
        <Text variant="bodyMd" as="p" color="subdued">
          Todas las transferencias tendrán de depósito de origen el depósito principal.
        </Text>
      </Layout.Section>
      <Layout.Section>
        <LegacyCard sectioned>
          <DropZone onDrop={handleDropZoneDrop}>
            {uploadedFiles}
            {fileUpload}
          </DropZone>
        </LegacyCard>
      </Layout.Section>
    </Layout>
  );
};
